<template>
  <div class="approval_detail" :style="'width:'+audit_width+'px;'">
    <div class="approval_header">{{approval_data.name}}({{approval_data.status}})</div>
    <div
      :style="'overflow: auto;margin:1px 0;height:'+(height-75)+'px;'"
      v-if="approval_data.flow_user_ids.length > 0"
    >
      <div class="fl details_content">
        <div class="bt approval_name">{{approval_data.name}}</div>
        <div class="bt approval_type">{{approval_data.type}}</div>
        <div
          class="bt"
        >{{approval_data.department}} {{approval_data.flow_user_ids[0].name}}/{{approval_data.create_time}}</div>
        <div class="approval_content bt">
          <span class="key_color" style="'width:100px;vertical-align: top;'">审批描述:</span>
          <span class="desc" style="width:500px" v-html="approval_data.description">
            <!-- {{approval_data.description}} -->
          </span>
        </div>
        <div class="flow_wrapper bt">
          <span class="key_color">流程：</span>
          <span v-for="(item,key) in approval_data.flow_user_ids" :key="key">
            <img src="../../assets/arrow.png" alt class="arrow" v-if="key>0" />
            <span
              :class="'flow_user '+(item.status == 2? 'approvaled_success':'') + (item.status == 3? 'approvaled_fail':'')"
            >{{item.name}}</span>
          </span>
        </div>
        <div class="chaosongren_wrapper">
          <span class="key_color">抄送人：</span>
          <span
            class="chaosongren"
            v-for="(item,key) in approval_data.cc_user_ids"
            :key="key"
          >{{item.username}}</span>
        </div>

        <div
          v-for="(item,key) in approval_data.flow_user_ids"
          :key="key"
          v-if="item.status !=1 && key>0"
          class="approval_content_wrapper"
        >
          <div style="border-top: 3px solid #ccc;"></div>
          <div class="fl approval_content_left" style="width:250px;">
            <div class="approval_user key_color">{{item.department}}-{{item.name}}</div>
            <div>{{item.reply_time}}</div>
            <div>
              <span
                v-if="!item.is_deliver"
                :class="'has_approval_icon '+(item.status == 2? 'approvaled_success_icon':'') + (item.status == 3? 'approvaled_fail_icon':'')"
              >
                {{item.status == 2?"同意":""}}
                {{item.status == 3?"拒绝":""}}
              </span>
              <span class="deliver_icon" v-else>转交</span>
            </div>
          </div>
          <div class="fl approval_content_right" style="width:500px;">{{item.opinion}}</div>
        </div>

        <!-- 审批 -->
        <div class="approval_content_wrapper border_t" v-if="audit_sumbit.can_sumbit">
          <div class="fl approval_content_left" :style="'width:'+approval_info_width+'px;'">
            <div class="approval_user key_color">{{audit_sumbit.name}}</div>
            <div>
              <span class="waiting_approval">待批</span>
            </div>
          </div>
          <div class="fl approval_content_right" style="width:400px">
            <textarea name id rows="6" class="approval_opion" v-model="approval_content"></textarea>
          </div>
          <div class="btns">
            <div class="approval_btn" @click="sunbmit_approval(2,audit_sumbit.flow_id)">同意</div>
            <div class="approval_btn" @click="sunbmit_approval(3,audit_sumbit.flow_id)">拒绝</div>
            <div class="approval_btn" @click="open_transfer">转交</div>
            <div class="approval_tips">{{sumbit_tips}}</div>
          </div>
        </div>

        <!-- 催办 -->
        <!-- <div class="approval_content_wrapper"  v-if="approval_data.flow_user_ids[1].status ==1 && approval_data.flow_user_ids[1].user_id != approval_data.user_id && user_info.user_id == approval_data.user_id">
                  <div class="btns">
                     <div class="approval_btn" @click="press_approval">催办</div>
                     <div class="approval_tips">
                        {{sumbit_tips}}
                     </div>
                  </div>
        </div>-->
      </div>
      <div class="fl documents_wrapper" v-if="approval_data.document_ids.length > 0">
        <div class="key_color">附件:</div>
        <div
          v-for="(item,key) in approval_data.document_ids"
          :key="key"
          class="document"
          @click="download(item.file.fileurl)"
        >{{item.name}}</div>
      </div>
    </div>
    <!-- 
      <el-dialog
         title="请选择转交人"
         :visible.sync="dialogVisible_transfer"
         width="30%"
         >
         <div>

            <el-select v-model="transfer_user_id"  :remote-method="getflowusers"  filterable remote placeholder="请选择转交人">
               <el-option
                  v-for="item in users"
                  :key="item.user_id"
                  :label="item.username"
                  :value="item.user_id">
               </el-option>
            </el-select>
         </div>
         <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible_transfer = false">取 消</el-button>
            <el-button type="primary" @click="flow_deliver">确 定</el-button>
         </span>
    </el-dialog>-->

    <div :class="{'none':!dialogVisible_transfer}" class="modal piaochuang_modal">
      <div class="zhezhao_mask" @click="mask_close()"></div>
      <div class="modal_content">
        <div class="biaoti_title">
          转交
          <span class="user_del fr">
            <img src="../../assets/del_icon.png" alt @click="mask_close()" />
          </span>
        </div>

        <div style="margin:10px 0 0 0;">
          <div style="display: inline-block;width:80px; text-align: center;line-height: 40px;">转交人</div>
          <div style="display: inline-block;width:81%;vertical-align: top;">
            <el-select
              v-model="transfer_user_id"
              :remote-method="getflowusers"
              filterable
              remote
              placeholder="请输入转交人"
            >
              <el-option
                v-for="(item,key) in flower_users"
                :key="key"
                :label="item.username"
                :value="item.user_id"
                v-if="item.user_id != user_info.user_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div style="margin:10px 0 0 0;">
          <div style="display: inline-block;width:80px; text-align: center;line-height: 40px;">转交意见</div>
          <div style="display: inline-block;width:80%;vertical-align: top;">
            <textarea
              rows="5"
              class="deliver_opion"
              v-model="deliver_content"
              placeholder="请输入转交意见"
            ></textarea>
          </div>
        </div>

        <div class="btns_container">
          <div class="_btn canceal_btn" @click="mask_close()">取消</div>
          <div class="_btn addbrandSumbit" @click="flow_deliver">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      approval_content: "",
      sunbmit: false,
      header: 60,
      pagination_height: 30,
      pageSize: 10,
      dialogAdd_approval: false,
      upload_file_data_approval: {},
      templates: [],
      approval_data: { flow_user_ids: [] },
      approval_info_width: 150,
      sumbit_tips: "",
      dialogVisible_transfer: false,
      flower_users: [],
      keyword: "",
      transfer_user_id: "",
      audit_sumbit: { can_sumbit: false, flow_id: null },
      audit_width: 1100,
      deliver_content: ""
    };
  },
  props: ["height", "width", "project_id", "web_token", "user_info", "web_url"],
  // store,
  methods: {
    backToLogin() {
      this.$router.push("/login");
    },
    // 获取审批详情
    get_detail() {
      this.$http
        .post(
          this.web_url + "/approval/" + this.approval_id,
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.approval_data = res.data.data;
            if (this.approval_data.status == "待审中") {
              for (
                var i = 0;
                i < this.approval_data.flow_user_ids.length;
                i++
              ) {
                var item = this.approval_data.flow_user_ids[i];
                if (item.status == 1) {
                  if (this.user_info.user_id == item.user_id) {
                    this.audit_sumbit.can_sumbit = true;
                    this.audit_sumbit.flow_id = item.id;
                    this.audit_sumbit.name = item.name;
                  }
                  break;
                } else {
                  this.audit_sumbit.can_sumbit = false;
                  this.audit_sumbit.flow_id = "";
                  this.audit_sumbit.name = "";
                }
              }
            } else {
              this.audit_sumbit.can_sumbit = false;
              this.audit_sumbit.flow_id = "";
              this.audit_sumbit.name = "";
            }
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          // console.log(res1);
        });
    },
    //提交审核
    sunbmit_approval: function(status, flow_id) {
      var _this = this;
      if (this.approval_content == "") {
        this.sumbit_tips = "审批意见不能为空";
        var aa = setTimeout(function() {
          _this.sumbit_tips = "";
        }, 3000);
        return false;
      }
      // var flow_id = null;
      // for(var i = 0; i < _this.approval_data.flow_user_ids.length; i++){
      //    if(_this.approval_data.flow_user_ids[i].status == 1){
      //        flow_id = _this.approval_data.flow_user_ids[i].id;
      //    }
      // }
      this.$http
        .post(
          this.web_url + "/approval/" + this.approval_id + "/flow_edit",
          {
            web_token: this.web_token,
            opinion: this.approval_content,
            status: status,
            flow_id: flow_id
          },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.get_detail();
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          } else {
            this.sumbit_tips = res.data.message;
            var aa = setTimeout(function() {
              _this.sumbit_tips = "";
            }, 3000);
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //转交
    flow_deliver() {
      var _this = this;
      if (this.flow_id == "") {
        this.sumbit_tips = "请填写转交人员";
        var aa = setTimeout(function() {
          _this.sumbit_tips = "";
        }, 2000);
        return false;
      }
      var flow_id = null;
      for (var i = 0; i < _this.approval_data.flow_user_ids.length; i++) {
        if (_this.approval_data.flow_user_ids[i].status == 1) {
          flow_id = _this.approval_data.flow_user_ids[i].id;
          break;
        }
      }
      this.$http
        .post(
          this.web_url + "/approval/" + this.approval_id + "/flow_deliver",
          {
            web_token: this.web_token,
            flow_id: flow_id,
            user_id: this.transfer_user_id,
            opinion: this.deliver_content
          },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.transfer_user_id = "";
            this.dialogVisible_transfer = false;
            this.get_detail();
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          } else if (res.data.status == "error") {
            this.sumbit_tips = res.data.message;
            var aa = setInterval(function() {
              _this.sumbit_tips = "";
            }, 2000);
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //  转交人
    open_transfer: function() {
      this.dialogVisible_transfer = true;
    },
    //关闭模态窗
    mask_close: function() {
      this.dialogVisible_transfer = false;
      //  $('table').find('tr').removeClass('selectedTr');
      //  $('.piaochuang_modal').addClass('none');
    },
    //催办
    press_approval(res) {
      var _this = this;
      this.$http
        .post(
          this.web_url + "/approval/" + this.approval_id + "/press",
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.sumbit_tips = "已给审批人员发起催办通知";
            setTimeout(function() {
              _this.sumbit_tips = "";
            }, 2000);
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          } else if (res.data.error_code == "error") {
            this.sumbit_tips = res.data.message;
            setTimeout(function() {
              _this.sumbit_tips = "";
            }, 2000);
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    getflowusers: function(keyword) {
      if (keyword.match(/^\s+$/) || keyword == "") {
        this.flower_users = [];
        return false;
      }
      this.$http
        .post(
          this.web_url + "/user_list",
          { web_token: this.web_token, keyword: keyword },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.flower_users = res.data.data;
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    download(url) {
      window.open(url);
    },
    placeholderSupport() {
      return "placeholder" in document.createElement("input");
    },
    placeholder() {
      if (!this.placeholderSupport()) {
        // 判断浏览器是否支持 placeholder
        $(document).ready(function() {
          //默认遍历循环添加placeholder
          $("[placeholder]").each(function() {
            $(this)
              .parent()
              .append(
                "<span class='placeholder'>" +
                  $(this).attr("placeholder") +
                  "</span>"
              );
          });
          $("[placeholder]").blur(function() {
            if ($(this).val() != "") {
              //如果当前值不为空，隐藏placeholder
              $(this)
                .parent()
                .find("span.placeholder")
                .hide();
            } else {
              $(this)
                .parent()
                .find("span.placeholder")
                .show();
            }
          });
        });
      }
    }
  },
  computed: {},
  mounted() {
    this.approval_id = this.$route.query.id;
    this.get_detail();
    this.placeholder();
  },
  created() {},
  watch: {},
  components: {}
};
</script>
 
<style>
.approval_detail {
  padding: 20px 0 0 15px;
  overflow: auto;
}
.approval_header {
  font-size: 18px;
  color: #03479c;
  border-bottom: 1px solid #ccc;
  line-height: 35px;
  margin-bottom: 10px;
  font-weight: bold;
}
.details_content {
  width: 780px;
  font-size: 14px;
  line-height: 24px;
}
.bt {
  border-bottom: 1px solid #ccc;
}
.approval_name {
  font-size: 16px;
  color: #03479c;
  font-weight: bold;
}
.approval_content {
  padding: 8px 0;
}
.flow_user {
  padding: 0 8px;
  line-height: 20px;
  background: #8c8c8c;
  color: #fff;
  display: inline-block;
}
.arrow {
  vertical-align: middle;
  height: 20px;
  width: auto;
}
.approvaled_success {
  background: #1796f7;
}
.approvaled_fail {
  background: black;
}
.flow_wrapper {
  padding: 8px 0;
}
.chaosongren {
  margin: 0 8px;
}
.chaosongren_wrapper {
  padding: 10px 0;
}
.none {
  display: none;
}
/* .approval_content_left{
  
     /* text-align: center; */
/* } */
* .approval_content_left .icon {
  height: 30px;
}
.approval_content_left .approval_user {
  font-size: 14px;
  line-height: 30px;
  font-weight: bold;
}
.approval_content_right {
  /* width: 70%; */
}
.key_color {
  color: #03479c;
}
.approval_content_wrapper {
  overflow: hidden;
  padding: 10px 0;
  width: 800px;
  /* border-bottom:1px solid #ccc; */
}
.waiting_approval {
  border: 1px solid #943a33;
  color: #943a33;
  line-height: 20px;
  padding: 0 5px;
  display: inline-block;
}
.approval_opion,
.deliver_opion {
  width: 100%;
  resize: none;
  border: 1px solid #c0c4cc;
}
.btns {
  clear: both;
  text-align: center;
  padding: 30px 0 0 0;
  overflow: hidden;
}
.approval_btn {
  display: inline-block;
  padding: 0 15px;
  line-height: 24x;
  background: #1796f7;
  color: #fff;
  cursor: pointer;
  margin: 0 10px;
  border-radius: 3px;
}
.documents_wrapper {
  margin: 10px 0 0 20px;
  font-size: 14px;
  color: #188dea;
  width: 280px;
  cursor: pointer;
}
.has_approval_icon {
  border-radius: 14px;
  font-size: 12px;
  display: inline-block;
  padding: 0 10px;
  line-height: 20px;
}
.deliver_icon {
  border-radius: 14px;
  font-size: 12px;
  display: inline-block;
  padding: 0 10px;
  line-height: 20px;
  border: 2px solid #3c9ef7;
  color: #3c9ef7;
}
.approvaled_success_icon {
  border: 2px solid #019a47;
  color: #019a47;
}
.approvaled_fail_icon {
  border: 2px solid black;
  color: black;
}
.document {
  word-wrap: none;
}
.approval_tips {
  text-align: center;
  color: red;
  font-size: 12px;
}
.desc {
  display: inline-block;
  word-wrap: none;
  min-height: 50px;
}
/*模态窗*/
.piaochuang_modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
}
.zhezhao_mask {
  background: #000;
  opacity: 0.5;
  opacity: alpha(opacity=50);
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=50);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}
.modal_content {
  position: absolute;
  width: 600px;
  height: 240px;
  margin-top: -150px;
  top: 50%;
  left: 50%;
  margin-left: -300px;
  background: #fff;
  z-index: 3;
  overflow: hidden;
  padding-bottom: 10px;
}
.biaoti_title {
  line-height: 35px;
  background-image: linear-gradient(#fafafa, #dedede);
}
.btns_container {
  text-align: center;
  margin-top: 10px;
}
.canceal_btn {
  background: #f0eceb !important;
  border: 1px solid #bfbfbf;
}
.modal_content .addbrandSumbit {
  background: #4489ca !important;
  margin-left: 20px;
  border: 1px solid #4489ca;
  color: #fff;
}
/* .modal_content {
   text-align: center;
} */
.modal_content .el-select {
  /* width: 80% !important; */
  display: block;
  /* margin: 30px auto; */
}
.btns_container ._btn {
  /* padding: 0 10px; */
  line-height: 28px;
  height: 28px;
  /* background:#f0eceb; */
  font-size: 14px;
  /* border-radius: 5px; */
  display: inline-block;
  cursor: pointer;
  width: 70px;
}
.user_del {
  display: inline-block;
  padding-right: 10px;
}
.user_del img {
  height: auto;
  width: 20px;
  /* line-height: 18px; */
  /* border-radius: 30px; */
  /* background: #ccc; */
  /* color: #fff; */
  margin: 0 0 0 8px;
  cursor: pointer;
  vertical-align: middle;
}
::-webkit-input-placeholder {
  font-size: 12px;
  font-family: "微软雅黑";
}
.border_t {
  border-top: 1px solid #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/page/auditing/auditing_detail.vue